import {
	getResponsiveParams
} from '../_utils';

export default {
	debug: IS_DEVELOP,
	route: {
		media: '/Media',
		ajax: {}
	},
	plugin: {
		slider: {
			preset: {
				building_card: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: false,
					multipleDrag: true,
					threshold: 30,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom true
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function () {},
					onChange: function () {
						this.updateActive();
					}
				},
				checked_builders: {
					duration: 200,
					easing: 'ease-out',
					perPage: getResponsiveParams(400, 3),
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: true, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: true, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function () {},
					onChange: function () {
						this.updateActive();
					}
				},
				building_view_gallery: {
					duration: 200,
					easing: 'ease-out',
					perPage: getResponsiveParams(180, 8),
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: false,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function () {},
					onChange: function () {
						this.updateActive();
					}
				},
				building_view_mobile_gallery: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function () {},
					onChange: function () {
						this.updateActive();
					}
				},
				building_progress: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function () {},
					onChange: function () {
						this.updateActive();
					}
				},
				gallery: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function () {
						this.printSlideIndexWithIndicator();
					},
					onChange: function () {
						this.updateActive();
						this.printSlideIndexWithIndicator();
					}
				},
				banner_reviews: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onChange: function () {
						this.updateActive();
					}
				}
			}
		},
		gmap: {
			common: {
				mapStyle: []
			}
		},
		toggle: {
			preset: {
				dropdown: {
					map: {
						'.dropdown': 'is-open',
						'body': 'dropdown-is-open'
					},
					stops: [
						'.dropdown__body'
					]
				},
				selectBox: {
					map: {
						'.select-box': 'is-open',
						'body': 'select-box-is-open'
					},
					stops: [
						'.select-box__content'
					]
				},
				shareDropdown: {
					map: {
						'.share-dropdown': 'is-open',
						'body': 'share-dropdown-is-open'
					},
					stops: [
						'.share-dropdown__body'
					]
				}
			}
		}
	}
};



// WEBPACK FOOTER //
// ./_HTML/src/js/_default-config/index.js